import { Component, OnInit } from '@angular/core';
import {DataListFilterColumn, Datalistviewcolumn} from 'src/app/shared/datalistview/columns/datalistviewcolumn';

@Component({
    selector: 'app-ratesets',
    templateUrl: './ratesets.component.html',
    styleUrls: ['./ratesets.component.scss'],
    standalone: false
})
export class RatesetsComponent implements OnInit {

  constructor() { }

  public Columns : Array<Datalistviewcolumn> = [
    new DataListFilterColumn("Name", "Name", true, "Name"),
    new Datalistviewcolumn("Description", "DescriptionString"),
  ];

  ngOnInit(): void {
  }

}
